import { AdminPermission } from '@bareun/db';

export const ADMIN_ROLES = Object.values(AdminPermission);

interface Permission {
  title: string;
  value: AdminPermission;
}

interface PermissionGroup {
  title: string;
  items: Permission[];
  multiple?: boolean;
}

export const ADMIN_PERMISSIONS = [
  {
    title: '관리자 보기',
    value: AdminPermission.ADMIN_READER
  },
  {
    title: '관리자 편집',
    value: AdminPermission.ADMIN_WRITER
  }
];
export const ADMIN_ROLE_PERMISSIONS = [
  {
    title: '역할 보기',
    value: AdminPermission.ADMIN_ROLE_READER
  },
  {
    title: '역할 편집',
    value: AdminPermission.ADMIN_ROLE_WRITER
  }
];

export const USER_ROLE_PERMISSIONS = [
  {
    title: '일반 유저',
    value: AdminPermission.USER_ROLE_API
  }
];

export const SEATTING_ADMIN_PERMISSIONS = {
  title: '권한',
  items: [
    ...ADMIN_PERMISSIONS,
    ...ADMIN_ROLE_PERMISSIONS,
    ...USER_ROLE_PERMISSIONS
  ]
};

export const PermissionGroupItems: PermissionGroup[] = [
  SEATTING_ADMIN_PERMISSIONS
];
